import * as Settings from './settings'
import * as TranscoHyperProxi from './transco-hyper-proxi'
import * as Suppliers from './suppliers'
import * as Nomenclatures from './nomenclatures'

let api: Api

export default class Api {
  [x: string]: any
  public Settings = Settings
  public TranscoHyperProxi = TranscoHyperProxi
  public Suppliers = Suppliers
  public Nomenclatures = Nomenclatures
}

export function getApi() {
  if (!api) {
    api = new Api()
  }
  return api
}
